<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="套餐及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="visaName">
              <a-input v-model="ruleForm.visaName" :maxLength="120" placeholder="建议填写签证商品名称">
                <span slot="addonAfter">{{ ruleForm.visaName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="入境次数">
              <a-input v-model="ruleForm.visaFrequency" :maxLength="20" placeholder="请输入入境次数"></a-input>
            </a-form-model-item>
            <a-form-model-item label="停留天数">
              <a-input v-model="ruleForm.visaDays" :maxLength="20" placeholder="请输入停留天数"></a-input>
            </a-form-model-item>
            <a-form-model-item label="有效期">
              <a-input v-model="ruleForm.visaDate" :maxLength="20" placeholder="请输入有效期"></a-input>
            </a-form-model-item>
            <a-form-model-item label="签证国家" required style="margin-bottom:0;">
              <a-row :gutter="20">
                <a-col :span="8">
                  <a-form-model-item prop="visaCountryId">
                    <a-select show-search :filter-option="filterOption" allowClear @change="changeCountry"
                              v-model="ruleForm.visaCountryId" placeholder="请选择" style="max-width:400px;">
                      <a-select-option v-for="item in foreignCountryList" :key="item.countryId" :value="item.countryId">
                        {{ item.countryName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="isChildName">
                  <a-form-model-item prop="visaProvinceId">
                    <a-select v-model="ruleForm.visaProvinceId" placeholder="请选择" style="max-width:400px;">
                      <a-select-option v-for="item in visaProvinceIdList" :key="item.provinceId"
                                       :value="item.provinceId">{{ item.provinceName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item label="签证类型" prop="visaType">
              <a-select v-model="ruleForm.visaType" style="max-width:700px;">
                <a-select-option :value="1">个人旅游</a-select-option>
                <a-select-option :value="2">商务</a-select-option>
                <a-select-option :value="3">探亲访友</a-select-option>
                <a-select-option :value="4">其他</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="送签地">
              <AreaKinkage
                v-model="ruleForm.areaList"
                ref="areaData"
                @getAreaData="getAreaData" :isshow="false" showText="*不选择表示支持“全国送签”"
                maxWidth="400px"></AreaKinkage>
            </a-form-model-item>
            <a-form-model-item label="出签率">
              <a-input v-model="ruleForm.visaProbability" :maxLength="20" placeholder="请输入出签率"></a-input>
            </a-form-model-item>
            <a-form-model-item label="办理时长">
              <a-input v-model="ruleForm.visaDuration" :maxLength="20" placeholder="请输入办理时长"></a-input>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="visaImg">
              <custom-upload-pro-images v-model="ruleForm.visaImg"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="受理范围">
              <a-textarea v-model="ruleForm.visaRange" :maxLength="1500" placeholder="请输入"
                          :auto-size="{minRows:8,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="预订须知">
              <a-textarea v-model="ruleForm.visaNotice" :maxLength="1500" placeholder="请输入"
                          :auto-size="{minRows:8,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <a-button v-if="proId!=0" @click="goEvent" style="margin-left: 10px">下一步</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import InvoiceSelect from '../components/InvoiceSelect'
import AreaKinkage from '@/customComponents/AreaKinkage/AreaKinkage'

export default {
  name: 'VisaBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    CustomUploadProImages,
    InvoiceSelect,
    AreaKinkage
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      foreignCountryList: [],//国家级
      ruleForm: {
        proId: this.$route.query.proId,
        visaCountryId: undefined,//签证国家ID
        visaDate: '',//有效期
        visaDays: '', //停留天数
        visaDuration: '',//办理时长
        visaFrequency: '',//入境次数
        visaImg: [],// 产品图片
        visaName: '',// 产品名称
        visaNotice: '', //预定须知
        visaProbability: '',//出签率
        visaRange: '',// 受理范围
        visaSiteCityId: '',//送签地城市ID
        visaSiteProvinceId: '',//送签地省份ID
        visaType: 1,// 签证类型 1个人旅游 2商务 3探亲访友 4其他
        visaProvinceId: undefined,
        invoiceTemplateId: undefined//发票
      },
      submitLoading: false,
      submitFormData: '',
      invoiceTemplateList: [],
      rules: {
        visaName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        visaType: [
          { required: true, message: '请选择签证类型', trigger: 'change' }
        ],
        visaCountryId: [
          { required: true, message: '请选择签证国家', trigger: 'change' }
        ],
        visaProvinceId: [
          { required: true, message: '请选择签证地', trigger: 'change' }
        ],
        visaImg: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ]
      },
      fileList: [],
      imageList: [],
      isChildName: false,
      visaProvinceIdList: []
    }
  },
  mounted() {
    this.getProductInfo()
    this.getForeignCountry()
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    changeCountry(id) {
      this.getLogUtils().logWithTag('changeCountry', id)
      let name = ''
      try {
        name = this.foreignCountryList.filter(item => {
          return item.countryId == id
        })[0].countryName
      } catch (err) {
        this.getLogUtils().logWithTag('error submit!!', '错误')
      }
      if (name == '中国') {
        this.isChildName = true
        this.getSpecialCity()
      } else {
        this.isChildName = false
      }
    },
    getSpecialCity() {
      this.getHttpServices().getProService().get('visa/getVisaDomestic').then(res => {
        this.getLogUtils().logWithTag('getForeignCountry', res)
        this.visaProvinceIdList = res
      }).catch(reason => {
        this.getLogUtils().logWithTag('getForeignCountry', reason)
      })
    },
    // 国家联动
    getForeignCountry() {
      this.getHttpServices().getBaseService().post('foreignCountry/getForeignCountryList').then(res => {
        this.getLogUtils().logWithTag('getForeignCountry', res)
        // this.foreignCountryList = res;
      }).catch(reason => {
        this.getLogUtils().logWithTag('getForeignCountry', reason)
        // 因为接口没有返会status为1，所以在错误里面取值
        if (reason.data) {
          this.foreignCountryList = reason.data
        }
      })
    },
    // 获取城市id
    getAreaData(data) {
      this.ruleForm.areaList = data
      if (data && data.length > 0) {
        this.ruleForm.visaSiteProvinceId = data[0]
        this.ruleForm.visaSiteCityId = data[1]
      } else {
        this.ruleForm.visaSiteProvinceId = ''
        this.ruleForm.visaSiteCityId = ''
      }
      this.getLogUtils().logWithTag('getAreaData', this.ruleForm.areaList)
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.visaImg = this.submitFormData.visaImg.length > 0 ? this.submitFormData.visaImg.join(',') : ''
      delete this.submitFormData.areaList
      this.getHttpServices().getProService().post('visa/saveOrUpdateVisa', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('签证基本信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'VisaProDes',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goEvent() {
      this.$router.push({
        name: 'VisaProDes',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    },
    // 获取基本信息
    getProductInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('visa/getProVisaDetails/' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getProductInfo', res)
          this.ruleForm = res
          if (res.visaSiteProvinceId && res.visaSiteCityId) {
            this.ruleForm.areaList = [res.visaSiteProvinceId, res.visaSiteCityId]
            this.$refs.areaData.getArea(this.ruleForm.areaList)
          }
          if (res.visaProvinceId) {
            this.changeCountry(this.ruleForm.visaCountryId)
          } else {
            this.ruleForm.visaProvinceId = undefined
          }
          this.ruleForm.visaImg = res.visaImg && res.visaImg != '' ? res.visaImg.split(',') : []
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.getLogUtils().logWithTag('getProductInfo', this.ruleForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.tThemeLevelMain {
  .tThemeLevelBtn {
    display: inline-block;
    margin-right: 15px;
    padding: 0 10px;
    border: 1px #ccc solid;
    border-radius: 5px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }

  .tThemeLevelBtn:hover {
    border: 1px #FAAD14 solid;
  }
}
</style>